import { Instant } from '@moojo/duration'
import { endpointDeclaration } from '@moojo/endpoints'
import { ShopIcp } from '@moojo/shop-icp'
import { z } from 'zod'

export const GetCalibrationRequest = z.object({
  calibrationId: z.string(),
})

export type GetCalibrationRequest = z.infer<typeof GetCalibrationRequest>

export const GetCalibrationResponse = z.object({
  timestamp: Instant.zod().optional(),
  agentId: z.string(),
  calibrationId: z.string(),
  calibrationUrl: z.string(),
  shopIcp: ShopIcp.optional(),
  productOffer: z
    .object({
      productName: z.string(),
      productUrl: z.string(),
      productImageUrl: z.string(),
    })
    .optional(),
})

export type GetCalibrationResponse = z.infer<typeof GetCalibrationResponse>

export const getCalibrationDeclaration = endpointDeclaration(GetCalibrationRequest, GetCalibrationResponse)
